import cleanText from './text/cleanText';

const getParagraphs = (text = ''): string[] => {
  return text.split('\n').map((paragraph) => cleanText(paragraph));
};

export default getParagraphs;
